module.exports = __webpack_public_path__ + "zvetseni-prsou_1_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zvetseni-prsou_1_before.jpg
// module id = 1312
// module chunks = 0